
  import React from "react"
  import Component from "/Users/stanislavpivovarov/Downloads/Telegram Desktop/headmade.github.io/src/layouts/index.js"
  import data from "/Users/stanislavpivovarov/Downloads/Telegram Desktop/headmade.github.io/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js